exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#customers[data-v-5a6ac057]{font-family:Trebuchet MS,Arial,Helvetica,sans-serif;border-collapse:collapse;width:100%}#customers td[data-v-5a6ac057],#customers th[data-v-5a6ac057]{border:2px solid #ddd;padding:8px;text-align:left;width:1%;white-space:nowrap}#customers tr[data-v-5a6ac057]:nth-child(2n){background-color:#f2f2f2}#customers tr[data-v-5a6ac057]:hover{background-color:#ddd}#customers th[data-v-5a6ac057]{padding-top:12px;padding-bottom:12px;text-align:center;background-color:#595a59;color:#fff}#auto[data-v-5a6ac057]{overflow-x:auto;width:100%}.numFont[data-v-5a6ac057]{font-size:12px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-5a6ac057","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/procurement/voucher/onlending_voucher_form.vue
// module id = 1456
// module chunks = 3